import { z } from "zod";
export const GetBriefResponse = z.object({
    id: z.string(),
    userId: z.string(),
    briefDate: z.string(),
    status: z.string(),
    title: z.string().nullable(),
    summary: z.string().nullable(),
    transcript: z.unknown().nullable(),
    sources: z.array(z.string()).nullable(),
    audioMime: z.string().nullable(),
    audioUrl: z.string().nullable(),
    rationale: z.string().nullable(),
    error: z.string().nullable(),
    playedAt: z.string().nullable().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const RecordBriefPlayedResponse = z.object({
    recorded: z.literal(true),
    playedAt: z.string(),
});
export const ListBriefsResponse = z.object({
    briefs: z.array(GetBriefResponse),
});
export const BriefAudioParams = z.object({ id: z.string() });
/**
 * Whether a brief's narration is ready to play. `rendering` carries a rough
 * time budget so the client can fill a progress bar; it never reports done
 * until the audio is saved.
 */
export const BriefAudioPrepareResponse = z.discriminatedUnion("state", [
    z.object({ state: z.literal("ready") }),
    z.object({
        state: z.literal("rendering"),
        estimatedSeconds: z.number().nonnegative(),
        elapsedSeconds: z.number().nonnegative(),
    }),
    z.object({ state: z.literal("unavailable") }),
]);
export const GenerateBriefQuery = z.object({ timezone: z.string().optional() });
export const GenerateBriefResponse = z.record(z.string(), z.unknown());
//# sourceMappingURL=brief.js.map